import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  headerContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  headerButton: {
    color: "white",
    display: "flex",
    justifyContent: "space-evenly",
    padding: `${theme.spacing(0.5)} ${theme.spacing(2)}`,
    borderRadius: theme.spacing(1),
    textTransform: "uppercase",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  filtersContainer: {
    dispaly: "flex",
    flexDirection: "row",
    marginTop: theme.spacing(4),
    flex: 1,
    alignItems: "center",
  },
}));

export default useStyles;
